import { createSlice } from "@reduxjs/toolkit";

const transactionSlice = createSlice({
    name: "transaction",
    initialState: {
        isLoading: true,
        transactionList: [],
        pagination: { pageNumber: 1, pageSize: 10, totalElements: 0, totalPages: 1, order: "asc", sortBy: "transaction_date" }
    },
    reducers: {
        setTransactionLoading: (state, { payload }) => {
            state.isLoading = payload;
        },
        setTransactionData: (state, { payload }) => {
            state.transactionList = payload;
        },
        setTxnPagination: (state, { payload }) => {
            state.pagination = payload;
        }
    }
});

export const { setTransactionLoading, setTxnPagination, setTransactionData } = transactionSlice.actions

export default transactionSlice.reducer;